import { MenuButton } from '../models';

export const MENU_BUTTONS: MenuButton[] = [
    {
        label: 'News',
        route: '/news',
        className: 'news-button'
    },
    // Shows and Schedule are hidden for now: shows were unpublished and the
    // Azura schedule is unavailable until the radio server is migrated.
    // {
    //     label: 'Shows',
    //     route: '/shows',
    //     className: 'shows-button'
    // },
    // {
    //     label: 'Schedule',
    //     route: '/schedule',
    //     className: 'schedule-button'
    // },
    {
        label: 'About',
        route: '/about',
        className: 'about-button'
    },
];
